import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Autocomplete,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseSendSMS } from "./UseSendSMS";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function SendOneSMS(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetMessages, SendSMS, validate } = UseSendSMS();
  const [messageRes, setMessageRes] = useState([]);
  const [messageText, setMessageText] = useState("");
  const [values, setValues] = useState();
  const [state, setState] = useState({
    id: undefined,
    mobile: undefined,
    value1: "",
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    value8: "",
    value9: "",
  });
  const [errorState, setErrorState] = useState({
    mobile: false,
    id: false,
  });
  const { isSmall } = useBreakpoints();

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("SMS1");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (props.expanded === "SMS1") {
      setProgress(true);
      GetMessages(true, (callback) => {
        setMessageRes(callback);
      });
    } else {
      setState({ id: undefined, mobile: undefined });
      setMessageText("");
      setMessageRes([]);
      setValues();
    }
  }, [props.expanded]);

  return (
    <Accordion
      id="SMS1"
      expanded={props.expanded === "SMS1"}
      onChange={handleChange("SMS1")}
      style={{
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            ارسال SMS تکی
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <Autocomplete
              size="small"
              value={state.id ? state.id : ""}
              onChange={(evt, newValue) => {
                if (newValue) {
                  setMessageText(
                    messageRes.find((m) => m.id == newValue)?.message
                  );
                  setState({ ...state, id: newValue });
                  setValues(messageRes.find((m) => m.id == newValue));
                } else {
                  setMessageText("");
                  setState({
                    ...state,
                    id: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return messageRes.find((m) => m.id == option).title;
                }
                return "";
              }}
              fullWidth
              options={messageRes.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  error={errorState.id}
                  variant="outlined"
                  {...params}
                  label="عنوان"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 8"}>
            <TextField
              fullWidth
              value={
                messageText
                  ? messageText
                      .replace(/(<([^>]+)>)/gi, "")
                      .replace(/(&nbsp;)/gi, " ")
                  : ""
              }
              label="پیام"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              multiline
              maxRows={10}
              InputProps={{
                readOnly: true,
              }}
              variant="filled"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 4"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.mobile ? state.mobile : ""}
              error={errorState.mobile}
              label="موبایل"
              sx={{ input: { direction: "rtl" } }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, mobile: evt.target.value });
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          {values && values.value1 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value1 ? state.value1 : ""}
                label="مقدار 1"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value1: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value2 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value2 ? state.value2 : ""}
                label="مقدار 2"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value2: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value3 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value3 ? state.value3 : ""}
                label="مقدار 3"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value3: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value4 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value4 ? state.value4 : ""}
                label="مقدار 4"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value4: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value5 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value5 ? state.value5 : ""}
                label="مقدار 5"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value5: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value6 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value6 ? state.value6 : ""}
                label="مقدار 6"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value6: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value7 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value7 ? state.value7 : ""}
                label="مقدار 7"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value7: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value8 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value1 ? state.value8 : ""}
                label="مقدار 8"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value8: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          {values && values.value9 ? (
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                value={state.value9 ? state.value9 : ""}
                label="مقدار 9"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, value9: evt.target.value });
                }}
              />
            </Box>
          ) : (
            ""
          )}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  SendSMS(state, () => {
                    setState({
                      id: undefined,
                      mobile: undefined,
                      value1: "",
                      value2: "",
                      value3: "",
                      value4: "",
                      value5: "",
                      value6: "",
                      value7: "",
                      value8: "",
                      value9: "",
                    });
                    setProgress(false);
                    setMessageText("");
                    setValues();
                  });
                }
              }}
            >
              ارسال
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
